import { useCallback } from 'react';
import { useHmiSocket } from 'features/hmi/hooks/useHmiSocket';
import {
  CLOUD_WATCH_TOPIC_SCHEME,
  UseWatchSocketReturn,
  createSharedSocketTransport,
  useWatchSocket,
} from 'greener-ui-library';

/**
 * Owns the shared watch connector for the HMI tabs (#1527), over the backend's `/hmi` namespace
 * proxy (#1603).
 *
 * Room membership is handled by the connector itself via the proxy's join/leave handshake.
 * The projects backend is the cloud proxy (``devices/{unitId}/...``), hence the cloud scheme.
 */
export const useWatchSocketConnection = (unitId: string | undefined): UseWatchSocketReturn => {
  const socketInstance = useHmiSocket(Boolean(unitId));

  const createTransport = useCallback(() => createSharedSocketTransport(socketInstance), [socketInstance]);

  return useWatchSocket({
    unitId: unitId ?? '',
    rooms: [
      'state',
      'feedback',
      'config/announcements',
      'timeseries',
      'assets/state',
      'assets/timeseries',
      'components/input_data',
      'components/output_data',
      'components/container_data',
      'metadata',
    ],
    topicScheme: CLOUD_WATCH_TOPIC_SCHEME,
    createTransport,
    enabled: Boolean(unitId && socketInstance),
  });
};
